"use client";

import dynamic from "next/dynamic";
import type { ComponentProps } from "react";

import type VideoAssetTemplate from "@/templates/VideoAsset";
import {
  ReadableCopy,
  ReadableVideoAsset,
  readableFallback,
} from "@/components/readable";

const VideoAsset = dynamic(() => import("@/templates/VideoAsset"), {
  ssr: false,
  loading: readableFallback("min-h-[600px]"),
});

export default function ClientOnlyVideoAsset(
  props: ComponentProps<typeof VideoAssetTemplate>,
) {
  return (
    <ReadableCopy
      copy={
        <ReadableVideoAsset page={props.page} locale={props.locale ?? "en"} />
      }
    >
      <VideoAsset {...props} />
    </ReadableCopy>
  );
}
